// extracted by mini-css-extract-plugin
export var disabled = "FeaturedImage-module--disabled--f-Nj-";
export var featuredImage = "FeaturedImage-module--featuredImage--LwMB7";
export var removeImage = "FeaturedImage-module--removeImage--7bC6J";